import { render, staticRenderFns } from "./DeleteAssessments.vue?vue&type=template&id=e94195ec"
import script from "./DeleteAssessments.vue?vue&type=script&lang=js"
export * from "./DeleteAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports